module.exports = __webpack_public_path__ + "static/media/slider-l4.747d82e7.webp";